
export type FlattenItem = {
    name: string;
    path: string;
    filePath: string;
    parentNames: string[];
    id: string;
}

export default (tree: TreeNestedItem[]) => {
    const flattenItems: FlattenItem[] = [];
    const searchLeaf = (items: TreeNestedItem[], parentNames: string[]) => {
        for (let index = 0; index < items.length; index++) {
            const item = items[index];

            // 排除禁用项
            if (item.disabled) {
                continue;
            }

            if (!item.children || item.children.length === 0) {
                flattenItems.push({
                    id: item.id,
                    name: item.name,
                    path: item.path,
                    filePath: item.filePath,
                    parentNames
                });
            }
            else {
                searchLeaf(item.children, parentNames.concat(item.name));
            }
        }
    };
    searchLeaf(tree, []);

    return flattenItems;
}